// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2JKqQ","image-link":"footer_image-link__11bgL","link":"footer_link__3BkYv"};